<template>
  <div class="images">
    <swiper :class="getClassName('current-image')" ref="currentImage" :options="swiperOptions">
      <swiper-slide class="current-image__item" v-for="img in images" :key="img.id">
        <v-img :src="img.src" :alt="img.alt" max-width="100%" :height="media ? '62.5vw' : '639px'" />
        <div :class="getClassName('current-image__caption')" v-if="img.caption">{{ img.caption }}</div>
      </swiper-slide>
    </swiper>

    <div class="thumbnails--sp" v-if="media">
      <swiper ref="thumbnails" :options="thumbsOptions">
        <swiper-slide class="thumbnails__item--sp" v-for="(img, index) in images" :key="img.id">
          <v-img
            :src="img.src"
            :alt="img.alt"
            width="46"
            height="46"
            :class="getClassNameThumbs('thumbnails__action', index)"
            @click="changeImage(index)"
          />
        </swiper-slide>
      </swiper>
      <div slot="button-prev" class="thumbnails__button--prev"></div>
      <div slot="button-next" class="thumbnails__button--next"></div>
    </div>
    <div class="thumbnails" v-else>
      <div v-for="(img, index) in images" :key="img.id">
        <v-img
          :src="img.src"
          :alt="img.alt"
          width="84"
          height="84"
          :class="getClassNameThumbs('thumbnails__action', index)"
          @click="changeImage(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper as SwiperClass, EffectFade, Navigation } from 'swiper/core';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
SwiperClass.use([EffectFade, Navigation]);
import 'swiper/swiper-bundle.css';

import getClassName from '../../_mixins/getClassName';

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
export default {
  mixins: [getClassName],
  components: {
    swiper: Swiper,
    'swiper-slide': SwiperSlide,
  },
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    const index = 0;
    return {
      index: index,
      swiperOptions: {
        speed: 1000,
        centeredSlides: true,
        loop: false,
        effect: 'fade',
      },
      thumbsOptions: {
        speed: 1000,
        centeredSlides: false,
        loop: false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.thumbnails__button--next',
          prevEl: '.thumbnails__button--prev',
        },
      },
    };
  },
  mounted() {
    this.swiper.on('slideChange', (swiper) => {
      this.index = swiper.activeIndex;
    });
  },
  computed: {
    getClassNameThumbs() {
      return (className, index) => {
        return [...this.getClassName(className), index === this.index ? className + '--active' : null];
      };
    },
    swiper() {
      return this.$refs.currentImage.$swiper;
    },
    thumbsSwiper() {
      return this.$refs.thumbnails ? this.$refs.thumbnails.$swiper : null;
    },
  },
  //   watch: {
  //     index(newState) {
  //       if (this.thumbsSwiper === null || this.thumbsSwiper.activeIndex === newState) return;
  //         this.thumbsSwiper.slideTo(newState);
  //     },
  //   },
  methods: {
    changeImage(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style lang="scss" scoped>
%__button {
  width: 8px;
  height: 8px;
  border-top: solid 1px #000;
  border-right: solid 1px #000;
  position: absolute;
  top: 50%;
}

.images {
  .current-image {
    width: 960px;
    margin: 0 auto;
    &--sp {
      width: 100%;
    }
    &__item {
      background: #fff;
      position: relative;
    }
    &__caption {
      background: #fff;
      padding: 5px;
      font-size: 1.2rem;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 20px;
      left: 20px;
      &--sp {
        bottom: 10px;
        left: 10px;
      }
    }
  }
  .thumbnails {
    width: 840px;
    margin: 24px auto 0;
    display: flex;
    flex-flow: row wrap;
    &--sp {
      width: 87.5%;
      padding: 0 33px;
      margin: 22px auto 0;
      box-sizing: border-box;
      position: relative;
    }
    &__item--sp {
      width: 46px;
      height: 46px;
    }
    &__action {
      border: solid 3px transparent;
      cursor: pointer;
    }
    &__button {
      &--prev {
        @extend %__button;
        left: 0;
        transform: translate(0, -50%) rotate(-135deg);
      }
      &--next {
        @extend %__button;
        right: 0;
        transform: translate(0, -50%) rotate(45deg);
      }
    }
  }
}
</style>
